(ns common.opensearch.facet-policy
  (:require
    [common.schema.data-types :as data-types]))

(def select-value-data-types
  #{:data.type/keyword
    :data.type/keyword-multi
    :data.type/ref-single
    :data.type/ref-multi
    :data.type/currency-symbol})

(def text-data-types
  #{:data.type/text
    :data.type/text-simple
    :data.type/text-url
    :data.type/email
    :data.type/email-multi
    :data.type/id
    :data.type/text-multi
    :data.type/url-multi
    :data.type/text-multiline
    :data.type/text-richtext})

(def text-no-value-facets-data-types
  #{:data.type/text-richtext
    :data.type/text-multiline
    :data.type/text-edn})

(def numeric-data-types
  #{:data.type/number
    :data.type/integer
    :data.type/long
    :data.type/percentage
    :data.type/multiplier
    :data.type/currency-value
    :data.type/date-year})

(def date-data-types
  #{:data.type/date
    :data.type/datetime})

(def bool-known-data-types
  #{:data.type/boolean
    :data.type/file})

(def no-facet-data-types
  #{:data.type/text-edn
    :data.type/financials
    :data.type/tesi-financials
    :data.type/tesi-financials-2})

(defn effective-filter-type
  [{:keys [data-type filter-type]}]
  (or filter-type
      (get-in data-types/zapflow-data-types [data-type :default-filter])))

(defn facet-policy
  [{:keys [data-type filter-type] :as _input}]
  (let [effective-filter-type (effective-filter-type {:data-type data-type
                                                      :filter-type filter-type})]
    (cond
      (or (nil? data-type)
          (contains? no-facet-data-types data-type)
          (= :filter.type/none effective-filter-type))
      {:fetch? false
       :facet-mode nil
       :value-facets? false
       :known-unknown-facets? false}

      (contains? date-data-types data-type)
      {:fetch? true
       :facet-mode :date-presets
       :value-facets? true
       :known-unknown-facets? true}

      (contains? numeric-data-types data-type)
      {:fetch? true
       :facet-mode :numeric-percentile-ranges
       :value-facets? true
       :known-unknown-facets? true}

      (contains? bool-known-data-types data-type)
      {:fetch? true
       :facet-mode nil
       :value-facets? true
       :known-unknown-facets? true}

      (contains? select-value-data-types data-type)
      {:fetch? true
       :facet-mode nil
       :value-facets? true
       :known-unknown-facets? true}

      (contains? text-data-types data-type)
      {:fetch? true
       :facet-mode nil
       :value-facets? (not (contains? text-no-value-facets-data-types data-type))
       :known-unknown-facets? true}

      ;; Fallback: allow if filter type is configured and not :none.
      :else
      {:fetch? (boolean effective-filter-type)
       :facet-mode nil
       :value-facets? true
       :known-unknown-facets? true})))

(defn should-fetch-facets?
  [{:keys [data-type filter-type]}]
  (true? (:fetch? (facet-policy {:data-type data-type
                                 :filter-type filter-type}))))

(defn facet-mode
  [{:keys [data-type filter-type]}]
  (:facet-mode (facet-policy {:data-type data-type
                              :filter-type filter-type})))
